import { MediaRole, MediaType } from '../../codegen/graphql';
import { api } from './api';

// Helper function to convert data URL to File
export function dataURLtoFile(dataUrl: string, filename: string): File {
  const arr = dataUrl.split(',');
  const mime = arr[0].match(/:(.*?);/)?.[1] || 'image/png';
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  
  return new File([u8arr], filename, { type: mime });
}

export async function uploadImages(
  files: Array<File | string>, 
  adId: string, 
  roles: MediaRole[],
) {
  const formData = new FormData();
  
  files.forEach((file, index) => {
    if (typeof file === 'string') {
      const fileObj = dataURLtoFile(file, `media-${index}.png`);
      formData.append('files', fileObj);
    } else {
      formData.append('files', file);
    }
  });

  return await api.post(`/uploads/${adId}/files?${roles.map(role => `roles[]=${encodeURIComponent(role)}`).join('&')}`, formData)
}

export async function toggleMediaRole(mediaId: string, role: MediaRole): Promise<Response> {
  return await api.put(`/uploads/files/${mediaId}/toggle-role`, { role })
}

export async function deleteImage(imageId: string): Promise<Response> {
  return await api.delete(`/uploads/files/${imageId}`)
}

export async function updateImageOrder(
  adId: string,
  updates: Array<{ id: string; position: number }>,
): Promise<Response> {
  return await api.put(`/uploads/${adId}/files/order`, { updates })
}

export async function updateMediaContent(
  mediaId: string, 
  file: File,
  editorData?: any
): Promise<Response> {
  const formData = new FormData();
  formData.append('file', file);
  
  if (editorData) {
    formData.append('editor_data', JSON.stringify(editorData));
  }

  return await api.put(`/uploads/files/${mediaId}/content`, formData)
}

export async function setMediaRoles(mediaId: string, roles: MediaRole[]) {
  return await api.put(`/uploads/files/${mediaId}/set-roles`, { roles })
}

export async function uploadMediaTranslation(
  file: File,
  mediaId: string,
  lang: string,
) {
  const formData = new FormData();
  formData.append('file', file);

  return await api.post(
    `/uploads/files/${mediaId}/translations?lang=${encodeURIComponent(lang)}`,
    formData,
  );
}

export async function downloadAdImagesZip(adId: string): Promise<Blob> {
  const response = await api.get(`/uploads/${adId}/images/download`);
  return response.blob();
}